import { inject, Provider, signal } from '@angular/core';

import { Cb2PreviewStateService } from '@core/services/cb2-preview/cb2-preview-state.service';

import {
  CART_SUGGESTION_CARDS_BLOCK_DATA_SOURCE,
  CART_SUGGESTION_CARDS_BLOCK_SUGGESTIONS_SET,
  CartSuggestionCardsBlockDataSource,
} from './cart-suggestion-cards-block-view-model';
import { CartSuggestionCardsBlockPreviewDataSource } from './cart-suggestion-cards-block-preview-data-source';
import { CartSuggestionCardsBlockStoreDataSource } from './cart-suggestion-cards-block-store-data-source';

export function provideCartSuggestionCardsBlockDataSource(): Provider[] {
  return [
    {
      provide: CART_SUGGESTION_CARDS_BLOCK_SUGGESTIONS_SET,
      useFactory: () => signal<string | undefined>(undefined),
    },
    CartSuggestionCardsBlockStoreDataSource,
    CartSuggestionCardsBlockPreviewDataSource,
    {
      provide: CART_SUGGESTION_CARDS_BLOCK_DATA_SOURCE,
      useFactory: (): CartSuggestionCardsBlockDataSource => {
        const previewState = inject(Cb2PreviewStateService);
        return previewState.isActive()
          ? inject(CartSuggestionCardsBlockPreviewDataSource)
          : inject(CartSuggestionCardsBlockStoreDataSource);
      },
    },
  ];
}
